export default __webpack_public_path__ + "static/media/LoggedOutMastImg.cd897e35.png";